import { v4 as uuidv4 } from 'uuid';
import { importFromPaste } from '@/services/paste.service';
import { getBundleIdMapByReference } from '@/features/bundles/bundles.service';

export function importPreparations(event, projectId, bundles) {
    const { rows } = importFromPaste(event);
    if (rows) {
        return rows.map((row) => parsePreparation(row, projectId, bundles));
    }
}
const isoDateRegex = /^\d{4}-\d{2}-\d{2}/;
const ddmmyyyyDateRegex = /^\d{2}\/\d{2}\/\d{4}/;
const yyyymmddDateRegex = /^\d{4}\/\d{2}\/\d{2}/;

export function parsePreparation(row, projectId, bundles) {
    const bundleMap = getBundleIdMapByReference(bundles);
    const preparation = {
        deliveryDuration: 5,
        phase: 'administrative',
        projectId,
        locationIds: [],
        predecessors: [],
        groupId: uuidv4(),
    };
    let rest = [];
    row.map((cell) => {
        const date = cell.substring(0, 10);
        if (bundleMap[cell]) {
            preparation.bundleId = bundleMap[cell];
        } else if (cell.match(isoDateRegex)) {
            preparation.emissionDueDate = new Date(date);
        } else if (cell.match(ddmmyyyyDateRegex)) {
            preparation.emissionDueDate = new Date(
                date[6] + date[7] + date[8] + date[9] + '-' + date[3] + date[4] + '-' + date[0] + date[1],
            );
        } else if (cell.match(yyyymmddDateRegex)) {
            preparation.emissionDueDate = new Date(
                date[0] + date[1] + date[2] + date[3] + '-' + date[5] + date[6] + '-' + date[8] + date[9],
            );
        } else if (cell.length > 0) {
            rest.push(cell);
        }
    });
    preparation.name = rest.join(' - ') || 'Nouvel Element';
    return preparation;
}
